import {Auth} from '../../../../modules/auth.js';

/**
 * @param {Array} carry
 * @param {object} lesson
 * @returns {Array}
 */
function flattenLessonItemsArray(carry, lesson) {
    const {lesson_items: lessonItems = []} = lesson;
    // eslint-disable-next-line unicorn/prefer-spread
    return carry.concat(lessonItems);
}

/**
 * @param {Array} lessonItems
 * @param {Array} highlights
 * @returns {Array}
 */
function mergeLessonItemsWithMatches(lessonItems, highlights) {
    return lessonItems.map((lessonItem, index) => {
        return {
            ...lessonItem,
            _highlightResult: {
                ...highlights[index],
            },
        };
    });
}

/**
 * @param {Array} lessonItems
 * @param {number} limit
 * @returns {Array}
 */
function getMatchedLessonItems(lessonItems, limit = 5) {
    return lessonItems.filter(({_highlightResult}) => _highlightResult.title.matchedWords.length).splice(0, limit);
}

export const courseSearchItemTemplate = (item, {html, components}) => {
    const {duration, url, objectID, lessons = [], _highlightResult, __position, __queryID} = item;
    const {lessons: matchedLessons = []} = _highlightResult;

    const lessonItems = lessons.reduce(flattenLessonItemsArray, []);
    const lessonItemMatches = matchedLessons.reduce(flattenLessonItemsArray, []);
    const mergedLessonItems = mergeLessonItemsWithMatches(lessonItems, lessonItemMatches);
    const matchedLessonItems = getMatchedLessonItems(mergedLessonItems);

    /**
     * @param {object} lessonItem
     * @param {?string} attribute
     * @param {?string} tag
     * @returns {object}
     */
    function generateHighlightForLessonItem(lessonItem, attribute = 'title', tag = 'b') {
        return components.Highlight({
            attribute,
            hit: lessonItem,
            highlightedTagName: tag,
        });
    }

    const highlightedDescription = components.Highlight({
        attribute: 'description',
        hit: item,
        highlightedTagName: 'b',
    });

    /**
     * @param {Array<object>} lessonItems
     * @returns {string|null}
     */
    function generateHtmlForMatchedLessons(lessonItems) {
        if (!lessonItems.length) {
            return null;
        }

        return html`<h4 class="searchItem__lessonItemHeading mb-small mt-small h5 font-normal">Lessons</h4>
            <ul>
                ${lessonItems.map((lessonItem) => {
                    if (Auth.guest()) {
                        return html`<li class="searchItem__lessonItem">
                            <div>${generateHighlightForLessonItem(lessonItem)}</div>
                        </li>`;
                    } else {
                        return html`<li class="searchItem__lessonItem">
                            <a
                                class="link searchItem__subLink"
                                href="${lessonItem.url}"
                            >
                                ${generateHighlightForLessonItem(lessonItem)}
                            </a>
                        </li>`;
                    }
                })}
            </ul>`;
    }

    const highlightedTitle = components.Highlight({
        attribute: 'title',
        hit: item,
        highlightedTagName: 'b',
    });

    return html`
        <div
            data-insights-object-id="${objectID}"
            data-insights-position="${__position}"
            data-insights-query-id="${__queryID}"
            class="searchItem searchItem--link pb-medium"
        >
            <div class="searchItem__type">Course</div>
            <h4 class="searchItem__heading h3 mt-none mb-small">
                <a class="searchItem__link" href="${url}">${highlightedTitle}</a>
            </h3>
            ${duration
                ? html`<div class="searchItem__tag">
                      <span class="visually-hidden">Duration: </span> ${duration} weeks
                  </div>`
                : ''}
            <div class="searchItem__content">
                <p class="truncate-3 mb-small">${highlightedDescription}</p>
            </div>
            ${generateHtmlForMatchedLessons(matchedLessonItems, url)}
            <div class="searchItem__callToAction link">View course</div>
        </div>
    `;
};
